import { useOnScrollBottom } from "../hooks/use-on-scroll-bottom";
import { StreamingArrayLoader } from "hoksource";
import * as React from "react";
export function useInfiniteScroll(config) {
    var configRef = React.useRef();
    configRef.current = config;
    var dataLoaderRef = React.useRef();
    if (!dataLoaderRef.current) {
        dataLoaderRef.current = new StreamingArrayLoader({
            getItems: filter => configRef.current.getItems(filter)
        });
        dataLoaderRef.current.maxTakeCount = config.maxTakeCount;
    }
    var scrollBottomCallbackRef = React.useRef();
    var disposedRef = React.useRef();
    var state;
    var dispatch;
    // can be optimized
    const createContext = () => ({
        isLoadingNext: dataLoaderRef.current.isLoadingNext,
        loadedItems: dataLoaderRef.current.loadedItems.slice() // for react
        ,
        reset: () => {
            dispatch({ type: 'reset' });
        },
        setLoadedItems: (items) => {
            dispatch({ type: 'setLoadedItems', items: items });
        }
    });
    [state, dispatch] = React.useReducer((state, action) => {
        // var ctx:typeof createContext;
        switch (action.type) {
            case 'reset':
                dataLoaderRef.current.reset();
            case 'loadNext':
                dataLoaderRef.current.loadNext()
                    .then(e => {
                    if (!disposedRef.current) {
                        dispatch({ type: 'loaded' });
                    }
                });
            case 'loaded':
                let ctx = createContext();
                /*
                if(config.onStateChange)
                {
                    config.onStateChange({target:ctx});
                }*/
                return ctx;
            case 'setLoadedItems':
                dataLoaderRef.current.loadedItems = action.items;
                return createContext();
            default:
                throw new Error();
        }
    }, createContext());
    React.useEffect(() => {
        /*
        var dataLoader = dataLoaderRef.current = new HokStreamingArrayLoader<T>({
            getItems: filter => configRef.current.getItems(filter)

        });
        dataLoader.maxTakeCount = config.maxTakeCount;
        */
        scrollBottomCallbackRef.current = () => {
            // console.log("on scroll bottom");
            // console.log(dataLoaderRef.current);
            if (dataLoaderRef.current.hasNext && !dataLoaderRef.current.isLoadingNext) {
                dispatch({ type: 'loadNext' });
            }
        };
        return () => {
            disposedRef.current = true;
        };
    }, []);
    useOnScrollBottom(config.targetElement, scrollBottomCallbackRef.current);
    return state;
}
//# sourceMappingURL=use-infinite-scroll.js.map